import {
  Card,
  CardContent,
  Button,
  Typography,
  Chip,
  Paper
} from '@mui/material';
import { useState, useEffect } from 'react';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import { useNavigate } from 'react-router';
import { isItemInLocalStorage } from 'src/Utils';
// ADD A BACK BUTTON TO ROUTE TO PRODUCTS PAGE

const displayName = isItemInLocalStorage('displayName')
  ? localStorage.getItem('displayName')
  : null;
const user = {
  name: displayName || 'Guest',
  avatar: '/static/images/avatars/1.jpg',
  jobtitle: 'Project Manager'
};

const AdminDetailsPage = () => {
  const navigate = useNavigate();
  const [currentUser, setCurrentUser] = useState<any>(null);

  const handleBackClick = () => {
    navigate('/product'); // Navigate back to the products page
  };

  useEffect(() => {
    const loggedInUser = JSON.parse(localStorage.getItem('user') || '{}');
    setCurrentUser(loggedInUser);
  }, []);

  if (!currentUser) {
    return <h1>There is no current user logged in.</h1>;
  }

  return (
    <div
      style={{
        minHeight: '100vh',
        backgroundImage: 'linear-gradient(to bottom right, #f9fafb, #f3f4f6)',
        padding: '2rem'
      }}
    >
      <div
        // look at this classname above and convert it to an inline style object
        style={{
          maxWidth: '72rem',
          margin: '0 auto'
        }}
      >
        <Card>
          <CardContent>
            {/* Header Section */}
            <div
              style={{
                display: 'flex',
                justifyContent: 'space-between',
                alignItems: 'center',
                marginBottom: '1rem'
              }}
            >
              <Button
                startIcon={<ArrowBackIcon />}
                variant="outlined"
                onClick={handleBackClick}
                size="small"
              >
                Back to Products
              </Button>

              <Chip
                // label="Active Status"
                label={currentUser.active ? 'Active' : 'Inactive'}
                color={currentUser.active ? 'success' : 'error'}
                variant="outlined"
                className="h-8"
              />
            </div>

            {/* Title Section */}
            <div className="border-b border-gray-200 pb-4">
              <Typography
                variant="h4"
                component="h1"
                className="font-bold text-gray-900"
                // look at this classname above and convert it to an inline style object
                style={{
                  fontSize: '1.5rem',
                  fontWeight: 700,
                  color: 'rgba(0, 0, 0, 0.87)'
                }}
              >
                Admin Profile
              </Typography>
              <Typography
                variant="subtitle1"
                color="text.secondary"
                className="mt-2"
              >
                Manage and view administrator information
              </Typography>
            </div>
            {/* User Details Section */}

            {/* START */}
            <div className="order-delivery-card">
              {/* Personal Information Card */}
              <Paper elevation={1} sx={{ p: 2, mb: 2 }}>
                <Typography variant="caption" color="text.secondary">
                  Personal Information
                </Typography>
                <Typography
                  variant="body1"
                  className="order-delivery-info-item"
                >
                  <span>Full Name:</span> <span style={{}}></span>
                  <span style={{ textAlign: 'right' }}>{currentUser.name}</span>
                </Typography>
                <Typography
                  variant="body1"
                  className="order-delivery-info-item"
                >
                  <span>Email:</span> <span style={{}}></span>
                  <span style={{ textAlign: 'right' }}>
                    {currentUser?.email}
                  </span>
                </Typography>
                <Typography
                  variant="body1"
                  className="order-delivery-info-item"
                >
                  <span>Phone Number:</span> <span style={{}}></span>
                  <span style={{ textAlign: 'right' }}>
                    {currentUser?.userStaffInfo?.phoneNumber}
                  </span>
                </Typography>
              </Paper>
              {/* ROLES & PERMISSIONS */}
              <Paper elevation={1} sx={{ p: 2, mb: 2 }}>
                <Typography variant="caption" color="text.secondary">
                  Roles And Permissions
                </Typography>

                <Typography
                  variant="body1"
                  className="order-delivery-info-item"
                >
                  <span>Job Title:</span> <span style={{}}></span>
                  <span style={{ textAlign: 'right' }}>{user.jobtitle}</span>
                </Typography>
                {/* FOR ROLES */}
                <Typography
                  variant="body1"
                  className="order-delivery-info-item"
                >
                  <span>Roles:</span> <span style={{}}></span>
                  <span style={{ textAlign: 'right' }}>
                    {currentUser.roles.map((r: any) => r.roleName).join(', ')}
                  </span>
                </Typography>

                <Typography
                  variant="body1"
                  className="order-delivery-info-item"
                >
                  <span>Permissions:</span> <span style={{}}></span>
                  <span style={{ textAlign: 'right' }}>
                    {currentUser.permissions
                      .map((p: any) => p.permissionName)
                      .join(', ')}
                  </span>
                </Typography>
                <Typography
                  variant="body1"
                  className="order-delivery-info-item"
                >
                  <span>Staff ID:</span> <span style={{}}></span>
                  <span style={{ textAlign: 'right' }}>
                    {currentUser?.userStaffInfo?.id}
                  </span>
                </Typography>

                {/* to show active */}
                <Typography
                  variant="body1"
                  className="order-delivery-info-item"
                >
                  <span>Active:</span> <span style={{}}></span>
                  <span style={{ textAlign: 'right' }}>
                    {currentUser.active ? 'Yes' : 'No'}
                  </span>
                </Typography>
              </Paper>

              {/* ACCOUNT DETAILS CARD */}
              <Paper elevation={1} sx={{ p: 2, mb: 2 }}>
                <Typography variant="caption" color="text.secondary">
                  Account Details
                </Typography>

                <Typography
                  variant="body1"
                  className="order-delivery-info-item"
                >
                  <span>Account created at:</span> <span style={{}}></span>
                  <span style={{ textAlign: 'right' }}>
                    {new Date(
                      currentUser?.userStaffInfo?.createdAt
                    ).toLocaleDateString()}
                    {/* convert to date format */}

                    {/* {new Date(currentUser.createdAt).toLocaleDateString()} */}
                  </span>
                </Typography>
                <Typography
                  variant="body1"
                  className="order-delivery-info-item"
                >
                  <span>Account updated at:</span> <span style={{}}></span>
                  <span style={{ textAlign: 'right' }}>
                    {new Date(
                      currentUser.userStaffInfo?.updatedAt
                    ).toLocaleDateString()}
                    {/* convert to date format */}

                    {/* {new Date(currentUser.createdAt).toLocaleDateString()} */}
                  </span>
                </Typography>
              </Paper>
            </div>
            {/* END */}

            {/* Grid Layout */}
          </CardContent>
        </Card>
      </div>
    </div>
  );
};

export default AdminDetailsPage;
